import {connect} from 'react-redux';
import Checkout from './Checkout.jsx';
import {displayClearCartConfirmation} from '../shared/actionTypes';
import {handleContinueShoppingClick} from '../shared/actions';
import {handleWebHooksClick} from 'shared/webHooks/actions';
import {ENVIRONMENT} from 'shared/variables';

import {
  openPaymentDialog,
  createPaymentClientSecret,
  handleAgreeToTermsClick,
} from './actions';

const mapStateToProps = state => ({
  ...state.registration.base,
  ...state.registration.payment,
  environment: ENVIRONMENT
});

const mapDispatchToProps = dispatch => ({
  onClearCartClick: () => dispatch(displayClearCartConfirmation(true)),
  onPay: paymentDetail => dispatch(openPaymentDialog(paymentDetail)),
  onCreatePaymentClientSecret: paymentDetail => dispatch(createPaymentClientSecret(paymentDetail)),
  onContinueShoppingClick: () => dispatch(handleContinueShoppingClick()),
  onAgreeToTermsClick: (checked) => dispatch(handleAgreeToTermsClick(checked)),
  onWebHooksClick: (checked) => dispatch(handleWebHooksClick(checked))
});

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);



// WEBPACK FOOTER //
// ./src/features/registration/checkout/CheckoutContainer.jsx